import { chips, ArticleFilterTabType } from './../dashboard/dashboard.component';
import { Subject, debounceTime, takeUntil } from 'rxjs';
import { KeyTitleModel } from './../../models/key-value-model';
import { LoaderService } from './../../services/loader.service';
import { BusinessService } from './../../services/business.service';
import {
  AfterViewInit, Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  OnDestroy,
  TemplateRef,
  inject
} from '@angular/core';
import { NgbDropdown, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { zip } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { FormControl, FormGroup } from '@angular/forms';
import { BusinessFilter } from 'src/app/models/register-business';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { ToastrService } from 'ngx-toastr';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocationSearchComponent } from 'src/app/shared/components/location-search/location-search.component';
import { MobileLocationDockComponent } from 'src/app/shared/components/mobile-location-dock/mobile-location-dock.component';
import { hasNativeLoginBridge, hasNativeScanBridge } from 'src/app/shared/auth/auth-runtime-context';

@Component({
  selector: 'app-listing-search',
  templateUrl: './listing-search.component.html',
  styleUrls: ['./listing-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ListingSearchComponent implements AfterViewInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private mapInitialized = false;
  private currentPage = 0;
  private limit = 10;
  private baseIndex = 0;  // Track the base index for pagination
  private totalPage = 1;  // Total number of pages
  private loadDataSubject = new Subject<void>();  // Subject for loading data

  @ViewChild('mapElement') mapElement: ElementRef;
  defaultCenter: any = {};

  @Input() set resturantCoordinates(value: any) {
    this._resturantCoordinates = value;

    if (value && value.length > 0) {
      this.clearAutoZoomPendingTimeout();
      this.isAutoZoomStepPending = false;
      if (this.map) {
        this.isLoading = false;
        this.updateMapMarkers(value, Date.now() < this.searchMapMoveSuppressedUntil);
        this.tryApplyRestoredSearch();
      } else {
        this.pendingRestaurantCoordinates = [...value];
        this.isLoading = false;
      }
    } else if ((this.searchText == null || this.searchText == "" || this.searchText == undefined) && (this.map && this.map.getZoom() > this.defaultMinZoom) && this.initialAutoZoom) {
      if (!this.applyEmptyRestaurantUpdate()) {
        this.clearAutoZoomPendingTimeout();
        this.isLoading = false;
      }
    }
    else {
      this.clearAutoZoomPendingTimeout();
      if (this.map) {
        this.markers.forEach(m => m.setMap(null));
        if (this.markerClusterer) {
          this.markerClusterer.setMap(null);
          this.markerClusterer = null;
        }
      }
      this.isLoading = false;
    }
  }

  _resturantCoordinates: any;

  get resturantCoordinates() {
    return this._resturantCoordinates;
  }

  active = 'place';
  activeInner = '1';
  city: string = "";
  previousText: string = '';
  delay: number = 500; // Delay for text search
  searchChanged: Subject<string> = new Subject<string>();
  filterChanged: Subject<any> = new Subject<any>();
  restaurantLocationLat: number = 0.00;
  restaurantLocationLng: number = 0.00;
  isMouseOverBlock: boolean = false;
  displayFilterChips: chips[] = [];
  articleFilterTabType = ArticleFilterTabType;

  @Input() isSearchBarActive: boolean = false;
  @ViewChild('myDrop') myDrop: NgbDropdown;
  @ViewChild("restaurantSearchBar") restaurantSearchBarElement: any;
  @ViewChild('desktopLocationSearch') desktopLocationSearch?: LocationSearchComponent;
  @ViewChild('mobileLocationDock') mobileLocationDock?: MobileLocationDockComponent;

  @Output() filterChanges = new EventEmitter<BusinessFilter>();
  @Output() cityEmitted = new EventEmitter<Object>();
  @Output() centerChange = new EventEmitter<Object>();
  isExpandList: boolean = false;

  selectedLocation: { lat: number; lng: number; address: string } | null = null;
  isMobileLocationSearchOpen: boolean = false;
  mobileLocationOriginRect: { left: number; width: number } | null = null;
  get mobileLocationLabel() {
    return this.selectedLocation?.address || 'Location';
  }
  get hasMobileLocationSelection() {
    return !!this.selectedLocation?.address;
  }

  // Add new properties
  private locationSearchSubject = new Subject<string>();
  isLoadingLocations = false;
  locationSuggestions: any[] = [];
  lastEpicenter: google.maps.LatLngLiteral | null = null;
  markerClusterer!: MarkerClusterer;
  hasFitBoundApply: boolean = false;
  isShowMessage: boolean = false;
  isMobileView: boolean;
  isFromMobileApp: boolean = false;
  isDesktopLocationSearchOpen: boolean = false;
  isDesktopLocationOpening = false;
  isDesktopLocationClosing = false;
  previousZoom: number | null = null;
  initialLoad: boolean = true;
  initialAutoZoom: boolean = true;
  isDraging: boolean = false;
  private preSearchZoom: number | null = null;
  private preSearchCenter: google.maps.LatLngLiteral | null = null;
  private restoredMapCenter: google.maps.LatLngLiteral | null = null;
  private restoredMapZoom: number | null = null;
  private userCenter: google.maps.LatLngLiteral | null = null;
  private isResettingToUserLocation = false;
  private pendingSearchRestore = false;
  private restoredFromSession = false;
  private pendingRestaurantCoordinates: any[] | null = null;
  private pendingExpandList = false;
  private pendingEmptyRestaurantUpdate = false;
  private isAutoZoomStepPending = false;
  private isDashboardLocationIntent = false;
  private searchMapMoveSuppressedUntil = 0;
  private autoZoomPendingTimeout: any;
  private mapInteractionUnsubscribers: Array<() => void> = [];
  @Output() showSearchChanges = new EventEmitter<any>();
  searchTimeout: any;
  private desktopLocationMotionTimeout: any;
  private lastMobileLocationTouchAt = 0;
  idleTimeout: any;
  clearLocation: boolean = false;
  @ViewChild('filterDropdownMenu') filterDropdownMenu: ElementRef;
  @ViewChild('scrollBarContainer') scrollBarContainerRef!: ElementRef;
  scrollTimeout: any;
  defaultMaxZoom: number = 20;
  defaultMinZoom: number = 12;
  // Zoom levels removed per auto-unzoom step. 2 keeps the empty-result fallback fast
  // while business data is sparse; drop to 1 once more businesses are onboarded.
  private readonly autoZoomStepSize = 2;
  isLoading: boolean = false;

  constructor(
    private businessService: BusinessService,
    private loaderService: LoaderService,
    private userService: UserService,
    private renderer: Renderer2,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private deviceDetector: DeviceDetectorService
  ) {
    // Setup debounced search
    this.searchChanged.pipe(
      takeUntil(this.destroy$),
      debounceTime(300)
    ).subscribe(searchText => {
      this.performSearch(searchText);
    });

    // Setup debounced filter
    this.filterChanged.pipe(
      takeUntil(this.destroy$),
      debounceTime(300)
    ).subscribe(filter => {
      this.applyFilter(filter);
    });

    // Setup debounced location search
    this.locationSearchSubject.pipe(
      takeUntil(this.destroy$),
      debounceTime(300)
    ).subscribe(query => {
      if (query?.trim()) {
        this.searchLocations(query);
      } else {
        this.locationSuggestions = [];
      this.cdr.detectChanges();
        }
      });
    this.isMobileView = deviceDetector.isMobile();
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.isMobileView = this.deviceDetector.isMobile();
  }

  @HostListener('window:beforeunload')
  handleBeforeUnload() {
    this.persistListingState();
  }

  private async searchLocations(query: string) {
    this.isLoadingLocations = true;
    this.cdr.detectChanges();

    try {
      const geocoder = new google.maps.Geocoder();
      const result = await geocoder.geocode({
        address: query
      });

      if (result.results) {
        this.locationSuggestions = result.results.map(place => ({
          address: place.formatted_address,
          lat: place.geometry?.location.lat(),
          lng: place.geometry?.location.lng(),
          placeId: place.place_id
        })).slice(0, 5); // Limit to 5 suggestions
      } else {
        this.locationSuggestions = [];
      }
    } catch (error) {
      this.locationSuggestions = [];
    } finally {
      this.isLoadingLocations = false;
      this.cdr.detectChanges();
    }
  }

  onLocationSearch(event: any) {
    this.exitRestoreMode();
    const query = event.target.value?.trim();
    this.locationSearchSubject.next(query);
  }

  onLocationSelected(location: any) {
    this.exitRestoreMode();
    if (location && location.address) {
      this.isDashboardLocationIntent = false;
      if (this.isDesktopLocationSearchOpen) {
        this.collapseDesktopLocationSearch();
      }
      this.clearLocation = false;
      this.initialAutoZoom = true;
      this.isLoading = true;
      this.city = location.address;
      this.selectedLocation = {
        lat: location.lat,
        lng: location.lng,
        address: location.address
      };
      this.filter.origin_Lat = location.lat.toString();
      this.filter.origin_long = location.lng.toString();
      this.filter.zoomLevel = this.defaultMaxZoom;
      this.filter.enableZoomFallBack = true;
      // Old viewport bounds belong to the previous location; sending them with the
      // new origin returns stale results that cancel the auto-zoom cycle.
      this.filter.north = null;
      this.filter.south = null;
      this.filter.east = null;
      this.filter.west = null;
      this.cityEmitted.emit({
        city: location.address,
        lat: location.lat,
        lng: location.lng,
        enableZoomFallBack: true,
      });
      this.showSearchChanges.emit([]);

      // Clear suggestions
      this.locationSuggestions = [];

      // Update map center
      if (this.map) {
        const newCenter = { lat: Number(location.lat), lng: Number(location.lng) };
        this.map.setCenter(newCenter);
        this.map.setZoom(this.defaultMaxZoom);
      }

      this.filterChanges.emit(this.filter);
      this.persistListingState();
      if (window.innerWidth < 767) {
        this.isMobileLocationSearchOpen = false;
      }
      this.cdr.detectChanges();
    } else if (location == null) {
      this.isDashboardLocationIntent = false;
      // Not an auto-zoom candidate: clearing must leave the map where the user left it.
      this.initialAutoZoom = false;
      this.clearLocation = false;
      this.city = '';
      this.selectedLocation = null;
      this.showSearchChanges.emit([]);
      this.markers.forEach(m => m.setMap(null));
      if (this.markerClusterer) {
        this.markerClusterer.setMap(null);
        this.markerClusterer = null;
      }
      // Emptying the field drops the location filter but keeps the editor open — only a real
      // interaction (outside tap, clear button, picking a suggestion) closes it.
      this.cdr.markForCheck();
      this.reloadForCurrentViewport();
    } else {
      console.warn('⚠️ Invalid location data:', location);
    }
  }

  ngAfterViewInit() {
    const hasRestoredCenter = !!this.restoredMapCenter;
    const filterCenter = this.getFilterCenter();
    const hasFilterCenter = !!filterCenter;
    if (hasRestoredCenter) {
      this.defaultCenter = { ...this.restoredMapCenter };
      if (this.filter?.origin_Lat == null || this.filter?.origin_long == null) {
        this.filter.origin_Lat = this.defaultCenter.lat.toString();
        this.filter.origin_long = this.defaultCenter.lng.toString();
      }
      if (this.restoredMapZoom != null && this.filter?.zoomLevel == null) {
        this.filter.zoomLevel = this.restoredMapZoom;
      }
      this.initMapIfReady();
    } else if (hasFilterCenter) {
      this.defaultCenter = { ...filterCenter };
      if (this.filter?.zoomLevel == null) {
        this.filter.zoomLevel = this.defaultMaxZoom;
      }
      this.initMapIfReady();
    }

    this.userService.getCurrentLatLng().then((position) => {
      this.userCenter = { lat: Number(position.lat), lng: Number(position.lng) };
      if (!hasRestoredCenter && !hasFilterCenter) {
        this.defaultCenter = { ...this.userCenter };
        if (this.filter?.origin_Lat == null || this.filter?.origin_long == null) {
          this.filter.origin_Lat = this.defaultCenter.lat.toString();
          this.filter.origin_long = this.defaultCenter.lng.toString();
        }
        if (this.filter?.zoomLevel == null) {
          this.filter.zoomLevel = this.defaultMaxZoom;
        }
        this.initMapIfReady();
      }
    },
      (error) => {
        if (!hasRestoredCenter && !hasFilterCenter) {
          this.defaultCenter = { lat: -0.7893, lng: 113.9213 };
          //this.defaultCenter = { lat: 23.0260736, lng: 72.5778432 };
          if (this.filter?.origin_Lat == null || this.filter?.origin_long == null) {
            this.filter.origin_Lat = this.defaultCenter.lat.toString();
            this.filter.origin_long = this.defaultCenter.lng.toString();
          }
          if (this.filter?.zoomLevel == null) {
            this.filter.zoomLevel = this.defaultMaxZoom;
          }
          this.initMapIfReady();
        }
      });

    this.setupEventListeners();
  }

  private getFilterCenter(): google.maps.LatLngLiteral | null {
    if (this.filter?.origin_Lat == null || this.filter?.origin_long == null) {
      return null;
    }
    const lat = Number(this.filter.origin_Lat);
    const lng = Number(this.filter.origin_long);
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return null;
    }
    return { lat, lng };
  }

  private async initMapIfReady() {
    if (this.mapElement?.nativeElement) {
      await this.waitForGoogleMaps();
      this.initMap();
    }
  }

  waitForGoogleMaps(): Promise<void> {
    return new Promise((resolve) => {
      const checkGoogle = () => {
        if ((window as any).google && (window as any).google.maps) {
          resolve();
        } else {
          setTimeout(checkGoogle, 100);
        }
      };
      checkGoogle();
    });
  }

  private async initMap() {
    if (!this.mapElement?.nativeElement) return;

    // Only initialize map if it doesn't exist
    if (!this.map) {
      const mapOptions: google.maps.MapOptions = {
        center: this.defaultCenter,
        zoom: this.defaultMaxZoom,
        mapTypeControl: false,
        zoomControl: true,
        streetViewControl: false,
        disableDefaultUI: true,
        mapId: 'AIzaSyBMs5Bji4teuZ4UxHHGm8X5lU7OnTNzaQc',
        draggable: true,
        disableDoubleClickZoom: true,
        maxZoom: this.defaultMaxZoom,
        minZoom: this.defaultMinZoom,
        gestureHandling: this.isMobileView ? "greedy" : "cooperative"
      };

      this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);
    }
    this.registerMapInteractionListeners();

    if (this.restoredMapCenter) {
      this.map.setCenter(this.restoredMapCenter);
      if (this.restoredMapZoom != null) {
        this.map.setZoom(this.restoredMapZoom);
      }
    }

    if (this.map.getCenter()) {
      this.lastEpicenter = this.map.getCenter()!.toJSON();
    }

    if (this.map.getZoom()) {
      this.previousZoom = this.map.getZoom()!;
    }

    google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
      this.setupIdleListener();
    });

    if (this.initialLoad) {
      this.setupIdleListener();
    }

    const coordinatesToApply = this.pendingRestaurantCoordinates?.length
      ? this.pendingRestaurantCoordinates
      : this._resturantCoordinates;

    if (coordinatesToApply?.length > 0) {
      await this.updateMapMarkers(coordinatesToApply);
      this.pendingRestaurantCoordinates = null;
    }
    else {
      this.markers.forEach(m => m.setMap(null));
      if (this.markerClusterer) {
        this.markerClusterer.setMap(null);
        this.markerClusterer = null;
      }
    }

    this.tryApplyRestoredSearch();
    this.mapInitialized = true;
    this.applyPendingExpandList();
    this.applyPendingEmptyRestaurantUpdate();
  }

  private setupIdleListener() {
    this.map.addListener('dragstart', () => {
      this.isDraging = true;
    });

    this.map.addListener('dragend', () => {
      this.isDraging = false;
    });

    this.map.addListener('idle', () => {
      if (!this.map) return;

      if (this.pendingExpandList) {
        this.applyPendingExpandList();
      }
      if (this.pendingEmptyRestaurantUpdate) {
        this.applyPendingEmptyRestaurantUpdate();
      }

      if (this.searchText == null || this.searchText == "" || this.searchText == undefined) {
        this.map.setOptions({ minZoom: this.defaultMinZoom });
      }
      const currentZoom = this.map.getZoom()!;
      const currentCenter = this.map.getCenter()?.toJSON();

      if (this.initialLoad) {
        const initialbounds = this.map.getBounds();
        const insetBounds = this.getInsetBounds(initialbounds, 0.1);
        this.previousZoom = currentZoom;
        this.lastEpicenter = currentCenter;
        this.filter.north = insetBounds.north.toString();
        this.filter.south = insetBounds.south.toString();
        this.filter.east = insetBounds.east.toString();
        this.filter.west = insetBounds.west.toString();
        this.filter.enableZoomFallBack = !!this.selectedLocation && this.initialAutoZoom;
        if (!this.restoredFromSession) {
          this.filterChanges.emit(this.filter);
          this.persistListingState();
        }
        this.initialLoad = false;
      }

      if (currentZoom !== this.previousZoom && (this.searchText == null || this.searchText == "" || this.searchText == undefined)) {
        const zoombounds = this.map.getBounds();
        const insetBounds = this.getInsetBounds(zoombounds, 0.1);
        const prevZoomlvl = this.filter.zoomLevel;
        this.previousZoom = currentZoom;
        this.clearAutoZoomPendingTimeout();
        this.isAutoZoomStepPending = false;
        this.toggleClustering(currentZoom);
        this.filter.origin_Lat = this.map.getCenter()?.lat()?.toString();
        this.filter.origin_long = this.map.getCenter()?.lng()?.toString();
        this.filter.north = insetBounds.north.toString();
        this.filter.south = insetBounds.south.toString();
        this.filter.east = insetBounds.east.toString();
        this.filter.west = insetBounds.west.toString();
        this.filter.zoomLevel = currentZoom;
        this.filter.enableZoomFallBack = !!this.selectedLocation && this.initialAutoZoom;
        if (!this.restoredFromSession && (prevZoomlvl != this.filter.zoomLevel || this.selectedLocation == null || this.selectedLocation == undefined || (this.filter.origin_Lat != this.selectedLocation.lat.toString() && this.filter.origin_long != this.selectedLocation.lng.toString()))) {
          this.filterChanges.emit(this.filter);
          this.persistListingState();
        }
      }

      clearTimeout(this.idleTimeout);
      this.idleTimeout = setTimeout(() => {
        if (!this.isDraging && (this.searchText == null || this.searchText == "" || this.searchText == undefined)) {
          if (this.lastEpicenter && (currentCenter.lat !== this.lastEpicenter?.lat || currentCenter.lng !== this.lastEpicenter?.lng)) {
            const distance = google.maps.geometry.spherical.computeDistanceBetween(
              new google.maps.LatLng(this.lastEpicenter),
              new google.maps.LatLng(currentCenter)
            );
            const threshold = this.getThresholdMetersFromViewport(this.map, 0.30);
            if (distance > threshold) {
              this.lastEpicenter = currentCenter;
              const dragbounds = this.map.getBounds();
              const insetBounds = this.getInsetBounds(dragbounds, 0.1);
              if (dragbounds) {
                if (!this.restoredFromSession) {
                  this.centerChange.emit({
                    lat: this.lastEpicenter.lat,
                    lng: this.lastEpicenter.lng,
                    zoom: currentZoom,
                    north: insetBounds.north,
                    south: insetBounds.south,
                    east: insetBounds.east,
                    west: insetBounds.west,
                    enableZoomFallBack: false
                  });
                  this.showSearchChanges.emit([]);
                }
              }
            }
          }
        }
      }, 1500);

      if (this.selectedLocation != null && this.selectedLocation != undefined) {
        const locatbounds = this.map.getBounds();
        const insetBounds = this.getInsetBounds(locatbounds, 0.1);
        this.filter.north = insetBounds.north.toString();
        this.filter.south = insetBounds.south.toString();
        this.filter.east = insetBounds.east.toString();
        this.filter.west = insetBounds.west.toString();
      }
    });
  }

  getViewportDimsMeters(map: google.maps.Map) {
    const b = map.getBounds();
    if (!b) return { width: 0, height: 0 };
    const ne = b.getNorthEast();
    const sw = b.getSouthWest();

    const west = new google.maps.LatLng(sw.lat(), sw.lng());
    const east = new google.maps.LatLng(sw.lat(), ne.lng());
    const width = google.maps.geometry.spherical.computeDistanceBetween(west, east);

    const south = new google.maps.LatLng(sw.lat(), sw.lng());
    const north = new google.maps.LatLng(ne.lat(), sw.lng());
    const height = google.maps.geometry.spherical.computeDistanceBetween(south, north);

    return { width, height };
  }

  getThresholdMetersFromViewport(map: google.maps.Map, fraction = 0.30) {
    const { width, height } = this.getViewportDimsMeters(map);
    const shorterRadius = Math.min(width, height) / 2;
    const MIN = 120;
    const MAX = 2500;
    const threshold = shorterRadius * fraction;
    return Math.max(MIN, Math.min(MAX, threshold));
  }

  private setupEventListeners() {
    const targetBlock = document.querySelector('.filter-dropdown');
    if (targetBlock) {
      this.renderer.listen(targetBlock, 'mouseenter', () => {
        this.isMouseOverBlock = true;
      });

      this.renderer.listen(targetBlock, 'mouseleave', () => {
        this.isMouseOverBlock = false;
      });
    }

    this.renderer.listen('window', 'scroll', () => {
      if (this.myDrop?.isOpen() && !this.isMouseOverBlock) {
        this.myDrop.close();
      }
    });

    if (this.restaurantSearchBarElement?.nativeElement) {
      this.renderer.listen(this.restaurantSearchBarElement.nativeElement, 'blur', (e: any) => {
        const searchBtn = document.querySelector('.btn-search');
        if (e && searchBtn && !searchBtn.contains(e.target)) {
          return;
        }

        if (!this.searchText) {
          this.isSearchBarActive = false;
          this.cdr.markForCheck();
        }
      });
    }
  }

  priceRanges: KeyTitleModel[] = [];
  typeOfMeals: KeyTitleModel[] = [];
  categories: KeyTitleModel[] = [];
  selectedPrices: boolean[] = [];
  selectedTypeOfMeals: boolean[] = [];
  selectedCategories: boolean[] = [];
  searchText: string;
  filter: BusinessFilter = new BusinessFilter();
  showOpen: boolean = false;
  showClose: boolean = false;
  isQRScanBtnClick = false;
  isFilterBtnClick = false;
  isSearchBtnClick = false;
  isLocationClicked: boolean = false;
  private markers: any[] = [];  // Using any[] temporarily to resolve type issues
  private map: google.maps.Map | null = null;

  loadFilterData() {
    this.loaderService.setLoading(true);
    zip(this.businessService.getAll(`api/tenants/membershipApp/getAllMembershipAppMealTypeList`),
      this.businessService.getAll(`api/tenants/membershipApp/GetAllMembershipAppCompanyPriceRange`),
      this.userService.getAll(`/api/tenants/membershipApp/GetMembershipAppCompanyTypes`),
    ).subscribe(([typeOfMeals, priceRanges, categories]: any[]) => {

      this.priceRanges = this.sortItems(priceRanges.map(item => ({
        id: item.id,
        title: item.title,
      })));

      this.typeOfMeals = this.sortItems(typeOfMeals.map(item => ({
        id: item.id,
        title: item.title,
      })));

      this.categories = this.sortItems(categories.map(item => ({
        id: item.id,
        title: item.title,
      })));

      this.loaderService.setLoading(false);

      //this.initMap();
    }, (err) => {
      this.loaderService.setLoading(false);

    });
  }

  sortItems(items: any[]): any[] {
    return items.slice().sort((item1, item2) => {
      if (item1.title.toLowerCase() < item2.title.toLowerCase()) {
        return -1;
      }
      if (item1.title.toLowerCase() > item2.title.toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }

  viewSearchBar(e) {
    this.exitRestoreMode();
    this.collapseDesktopLocationSearch();
    e.preventDefault();
    const windowWidth = window.innerWidth;
    if (this.isMobileLocationSearchOpen && !this.city) {
      this.isMobileLocationSearchOpen = false;
    }
    this.restaurantSearchBarElement.nativeElement.focus();
    if (windowWidth < 767) {
      if (this.isSearchBarActive && this.searchText) {
        const updatedFilter = { ...this.filter, search: this.searchText };
        this.applyFilter(updatedFilter);
      }
      this.isSearchBarActive = !this.isSearchBarActive;
      if (!this.isSearchBarActive) {
        this.restaurantSearchBarElement.nativeElement.blur();
      }
    }
    else if (this.searchText) {
      const updatedFilter = { ...this.filter, search: this.searchText };
      this.applyFilter(updatedFilter);
    }
  }

  showOpenResturant() {
    this.exitRestoreMode();
    this.collapseDesktopLocationSearch();
    this.showOpen = !this.showOpen;
    this.showClose = false;
    this.businessService.setCloseOpenValue({ showOpen: this.showOpen, showClose: this.showClose });
    this.businessService.onOpenClosedBtnClick.emit({ showOpen: this.showOpen, showClose: this.showClose });
    this.resetToUserLocationIfNoFilters();
  }

  showCloseResturant() {
    this.exitRestoreMode();
    this.collapseDesktopLocationSearch();
    this.showClose = !this.showClose;
    this.showOpen = false;
    this.businessService.setCloseOpenValue({ showOpen: this.showOpen, showClose: this.showClose });
    this.businessService.onOpenClosedBtnClick.emit({ showOpen: this.showOpen, showClose: this.showClose });
    this.resetToUserLocationIfNoFilters();
  }

  initialCoordinates = {
    lat: 0.7893,
    lng: 113.9213,
  };

  mapOptions: google.maps.MapOptions = {
    center: this.initialCoordinates,
    mapTypeControl: false,
    zoomControl: false,
    streetViewControl: false,
    disableDefaultUI: true,
    mapId: 'AIzaSyBMs5Bji4teuZ4UxHHGm8X5lU7OnTNzaQc'
  };

  coordinates = [];

  ngOnInit() {
    this.isFromMobileApp = hasNativeLoginBridge(window as any);
    this.restoreListingState();
    this.loadFilterData();
    if (this.businessService.filterDataObject) {
      this.filter = this.businessService.filterDataObject.filter;
      this.selectedCategories = Object.assign([], this.businessService.filterDataObject.selectedCategories);
      this.selectedPrices = this.businessService.filterDataObject.selectedPrices;
      this.selectedTypeOfMeals = this.businessService.filterDataObject.selectedTypeOfMeals;
      this.displayFilterChips = this.businessService.filterDataObject.displayFilterChips;
      if (this.displayFilterChips.length > 0) {
        this.isFilterBtnClick = true;
      }
      if (this.filter.search) {
        this.searchText = this.filter.search;
      }
      if (this.businessService.filterDataObject.city) {
        this.city = this.businessService.filterDataObject.city;
      }
      this.isDashboardLocationIntent = this.businessService.filterDataObject.source === 'dashboard-location';
      if (this.businessService.filterDataObject.selectedLocation) {
        this.selectedLocation = this.businessService.filterDataObject.selectedLocation;
        if (!this.city && this.selectedLocation?.address) {
          this.city = this.selectedLocation.address;
        }
        this.cityEmitted.emit({
          city: this.city,
          lat: this.selectedLocation.lat,
          lng: this.selectedLocation.lng,
          enableZoomFallBack: true,
        });
      }
      this.filterChanges.emit(this.filter);
    }

    const closeOpenResturant = this.businessService.getCloseOpenResturant();
    this.showOpen = closeOpenResturant.showOpen;
    this.showClose = closeOpenResturant.showClose;

    // Subscribe to restaurant list updates
    this.businessService.restaurantListUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(coordinates => {
        if (coordinates && coordinates.length > 0) {
          this.clearAutoZoomPendingTimeout();
          this.initialAutoZoom = false;
          this.isLoading = false;
          if (this.map) {
            this.updateMapMarkers(coordinates, Date.now() < this.searchMapMoveSuppressedUntil);
          } else {
            this.pendingRestaurantCoordinates = [...coordinates];
          }
        }
        else if (!this.map && (this.searchText == null || this.searchText == "" || this.searchText == undefined)) {
          this.pendingEmptyRestaurantUpdate = true;
          this.isLoading = false;
        }
        else if (this.applyEmptyRestaurantUpdate()) {
          this.pendingEmptyRestaurantUpdate = false;
        }
        else {
          this.clearAutoZoomPendingTimeout();
          this.isExpandList = false;
          this.markers.forEach(m => m.setMap(null));
          if (this.markerClusterer) {
            this.markerClusterer.setMap(null);
            this.markerClusterer = null;
          }
          this.isLoading = false;
          this.cdr.detectChanges();
        }
      });

    // Subscribe to coordinate updates for marker highlighting
    this.businessService.coordinatesEmitted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(location => {
        if (location && location.lat !== 0 && location.lng !== 0) {
          this.updateMarkerForLocation(location, './assets/images/location-listing-page-3.svg', true);
        }
      });

    // Subscribe to icon reset events
    this.businessService.changeIconEmitted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(location => {
        if (location && location.lat !== 0 && location.lng !== 0) {
          this.updateMarkerForLocation(location, './assets/images/location-listing-page.svg', false);
        }
      });

    this.businessService.expandListEmitted$
      .pipe(takeUntil(this.destroy$))
      .subscribe(expandList => {
        this.isExpandList = expandList;
        this.initialAutoZoom = true;
        this.applyPendingExpandList();
      });
  }

  private applyPendingExpandList() {
    if (!this.isExpandList) {
      return;
    }
    if (!this.map) {
      this.pendingExpandList = true;
      return;
    }
    const currentZoom = this.map.getZoom();
    if (typeof currentZoom !== 'number') {
      this.pendingExpandList = true;
      return;
    }
    const nextZoom = Math.max(currentZoom - this.autoZoomStepSize, this.defaultMinZoom);
    if (nextZoom === currentZoom) {
      this.pendingExpandList = false;
      this.isExpandList = false;
      return;
    }
    this.filter.zoomLevel = nextZoom;
    this.map.setZoom(this.filter.zoomLevel);
    const bounds = this.map.getBounds();
    if (!bounds) {
      this.pendingExpandList = true;
      return;
    }
    const insetBounds = this.getInsetBounds(bounds, 0.1);
    this.filter.origin_Lat = this.map.getCenter()?.lat()?.toString();
    this.filter.origin_long = this.map.getCenter()?.lng()?.toString();
    this.filter.north = insetBounds.north.toString();
    this.filter.south = insetBounds.south.toString();
    this.filter.east = insetBounds.east.toString();
    this.filter.west = insetBounds.west.toString();
    this.filter.enableZoomFallBack = true;
    this.pendingExpandList = false;
    this.filterChanges.emit(this.filter);
    this.persistListingState();
  }

  private applyPendingEmptyRestaurantUpdate() {
    if (!this.pendingEmptyRestaurantUpdate) {
      return;
    }
    if (this.applyEmptyRestaurantUpdate()) {
      this.pendingEmptyRestaurantUpdate = false;
    }
  }

  private applyEmptyRestaurantUpdate(): boolean {
    if (!this.map || !(this.searchText == null || this.searchText == "" || this.searchText == undefined)) {
      return false;
    }
    if (this.isAutoZoomStepPending) {
      this.scheduleAutoZoomPendingTimeout();
      this.isLoading = true;
      return true;
    }
    const currentCenter = this.map.getCenter()?.toJSON();
    const currentZoom = this.map.getZoom();
    if (typeof currentZoom !== 'number') {
      return false;
    }
    const nextZoom = Math.max(currentZoom - this.autoZoomStepSize, this.defaultMinZoom);
    const shouldAutoZoom = nextZoom < this.filter?.zoomLevel &&
      nextZoom >= this.defaultMinZoom &&
      this.initialAutoZoom &&
      (this.isExpandList ||
        this.selectedLocation != null ||
        (this.filter && (
          (currentCenter?.lat.toString() !== this.filter.origin_Lat && currentCenter?.lng.toString() !== this.filter.origin_long) ||
          (currentCenter?.lat.toString() === this.defaultCenter.lat.toString() && currentCenter?.lng.toString() === this.defaultCenter.lng.toString())
        )));

    if (!shouldAutoZoom) {
      this.clearAutoZoomPendingTimeout();
      this.isAutoZoomStepPending = false;
      return false;
    }

    this.isLoading = true;
    this.isAutoZoomStepPending = true;
    this.scheduleAutoZoomPendingTimeout();
    this.filter.enableZoomFallBack = true;
    this.map.setZoom(nextZoom);
    return true;
  }

  private scheduleAutoZoomPendingTimeout() {
    this.clearAutoZoomPendingTimeout();
    this.autoZoomPendingTimeout = setTimeout(() => {
      if (!this.isAutoZoomStepPending) {
        return;
      }
      this.isAutoZoomStepPending = false;
      this.pendingEmptyRestaurantUpdate = false;
      this.isLoading = false;
      this.cdr.markForCheck();
    }, 3000);
  }

  private clearAutoZoomPendingTimeout() {
    if (this.autoZoomPendingTimeout) {
      clearTimeout(this.autoZoomPendingTimeout);
      this.autoZoomPendingTimeout = null;
    }
  }

  // Helper method to update marker for a specific location
  private updateMarkerForLocation(location: any, iconPath: string, isHover: boolean) {
    const index = this.coordinates.findIndex(coord =>
      coord.position.lat === location.lat &&
      coord.position.lng === location.lng
    );

    if (index !== -1) {
      this.updateMarkerIcon(this.coordinates[index], index, iconPath, isHover);
    }
  }

  private async updateMapMarkers(coordinates: any[], skipMapAdjust: boolean = false) {
    if (!coordinates || coordinates.length === 0) {
      this.markers = [];
      this.removeClustering();
      return;
    }

    await this.initializeMarkers(coordinates);
    if (!this.map) {
      return;
    }
    if (skipMapAdjust) {
      // Typed name search must only filter the list/markers; the map stays where the user left it.
      const currentZoom = this.map.getZoom();
      if (typeof currentZoom === 'number') {
        this.toggleClustering(currentZoom);
      }
      return;
    }
    const zoom = this.getZoomLevelFromDistance(coordinates[coordinates.length - 1].distance);
    if (this.selectedLocation) {
      if (coordinates.length > 0) {
        const currentZoom = this.map.getZoom();
        if (typeof currentZoom === 'number') {
          this.toggleClustering(currentZoom);
        }
        this.map.setZoom(coordinates[0]?.zoomLevel);
      } else {
        const center = {
          lat: Number(this.selectedLocation.lat),
          lng: Number(this.selectedLocation.lng)
        };
        this.map.setCenter(center);
        this.map.setZoom(this.defaultMaxZoom);
      }
    } else if (this.city && this.filter.origin_Lat && this.filter.origin_long) {
      if (coordinates.length > 0) {
        const center = {
          lat: Number(coordinates[0]?.lat),
          lng: Number(coordinates[0]?.lng)
        };
        this.map.setCenter(center);
        this.map.setZoom(coordinates[0]?.zoomLevel);
      } else {
        const center = {
          lat: Number(this.filter.origin_Lat),
          lng: Number(this.filter.origin_long)
        };
        this.map.setCenter(center);
        this.map.setZoom(this.defaultMaxZoom);
      }
    } else {
      const currentZoom = this.map.getZoom();
      if (typeof currentZoom === 'number') {
        this.toggleClustering(currentZoom);
      }
      this.map.setZoom(coordinates[0]?.zoomLevel);

      if (this.isExpandList) {
        const listZoom = coordinates[0]?.zoomLevel;
        this.map.setZoom(listZoom);
        this.isExpandList = false;
      }

      if (this.initialLoad) {
        this.map.setZoom(coordinates[0]?.zoomLevel);
      }

      if (this.searchText) {
        this.map.setOptions({ minZoom: 0 });
        const bounds = new google.maps.LatLngBounds();

        coordinates.forEach((coord, index) => {
          bounds.extend({ lat: coord.lat, lng: coord.lng });
        });

        const padding = {
          top: 50,    // Reduced padding for better zoom
          right: 50,
          bottom: 50,
          left: 50
        };

        this.map?.fitBounds(bounds, padding);
      }
    }
  }

  private async toggleClustering(zoom: number) {
    if (zoom < 14) {
      this.applyClustering();
    }
    else {
      this.removeClustering();
    }
  }
  private async applyClustering() {
    if (this.markerClusterer) {
      this.markerClusterer.clearMarkers();
      this.markerClusterer.setMap(null);
      this.markerClusterer = null;
    }
    this.markers.forEach(m => m.setMap(null));
    if (this.markers.length >= 2) {
      this.markerClusterer = new MarkerClusterer({ map: this.map, markers: this.markers });
    } else {
      this.markers.forEach(m => m.map = this.map);
    }
  }
  private async removeClustering() {
    if (this.markerClusterer) {
      this.markerClusterer.setMap(null);
      this.markerClusterer = null;
    }
    this.markers.forEach(m => m.setMap(this.map));
  }

  private async initializeMarkers(coordinates: any[]) {
    if (!this.map) {
      return;
    }
    this.markers.forEach(marker => {
      if (marker && marker.setMap) {
        marker.setMap(null);
      }
    });
    const limitedCoordinates = coordinates.slice(0, 40).map((coord) => {
      return {
        ...coord,
        position: { lat: coord.lat, lng: coord.lng }
      };
    });

    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
    this.markers = [];
    // Add new markers without affecting the map center
    limitedCoordinates.forEach((coord) => {
      const element = document.createElement('div');
      element.innerHTML = `
        <div style="position: relative; cursor: pointer;">
          <img src="./assets/images/location-listing-page.svg" style="width: 45px; height: 56px;"/>
          <div style="position: absolute; top: 35%; left: 50%; transform: translate(-50%, -50%); color: white; font-size: 12px; font-weight: 500; font-family: Barlow;">
            ${coord.listingIndex}
          </div>
        </div>
        `;

      const marker = new AdvancedMarkerElement({
        position: coord.position,
        content: element,
        title: this.markerTitle(coord)
      });
      marker.addListener('click', () => {
        const listingElement = document.querySelector(`[data-listing-index="${coord.listingIndex}"]`);
        this.scrollToListing(coord.listingIndex);
      });
      this.markers.push(marker);
    });
    // Store coordinates for later use
    this.coordinates = limitedCoordinates;
  }

  /** Native hover tooltip / accessible name of a map pin: "3. Warung Sederhana", not "Location 3". */
  private markerTitle(coord: { listingIndex: number; name?: string }): string {
    const name = (coord?.name ?? '').toString().trim();
    return name ? `${coord.listingIndex}. ${name}` : `Location ${coord.listingIndex}`;
  }

  private getZoomLevelFromDistance(distance: number): number {
    if (distance <= 400) return 17;
    if (distance <= 1000) return 16;
    if (distance <= 2000) return 15;
    if (distance <= 4000) return 14;
    if (distance <= 8000) return 13;
    if (distance <= 16000) return 12;
    return 11;
  }
  /**
   * Card-hover highlight. Reuses the existing marker and swaps only the pin
   * image; the previous version detached the marker, awaited the marker library
   * and rebuilt element + listener from scratch on every hover in AND out.
   * Clustering handling is unchanged: uncluster while hovering so the pin is
   * visible, restore afterwards.
   */
  private async updateMarkerIcon(coord: any, index: number, iconPath: string, isHover: boolean) {
    const marker = this.markers[index];
    if (!marker) return;

    if (isHover) {
      this.removeClustering();
    }

    const img = (marker.content as HTMLElement | undefined)?.querySelector?.('img');
    if (img) {
      if (img.getAttribute('src') !== iconPath) {
        img.setAttribute('src', iconPath);
      }
    }
    // removeClustering/toggleClustering reassign markers' maps; make sure this one is shown.
    marker.map = this.map;

    if (!isHover) {
      const currentZoom = this.map.getZoom()!;
      this.toggleClustering(currentZoom);
    }
  }

  private scrollToListing(index: number) {
    const listingElement = document.querySelector(`[data-listing-index="${index}"]`);
    const container = document.querySelector('.restro-details-wrap');

    if (listingElement && container) {
      // Get the relative position of the listing element within the container
      const containerRect = container.getBoundingClientRect();
      const listingRect = listingElement.getBoundingClientRect();
      const relativeTop = listingRect.top - containerRect.top;

      // Scroll the container
      container.scrollTo({
        top: container.scrollTop + relativeTop - containerRect.height / 2 + listingRect.height / 2,
        behavior: 'smooth'
      });

      // Add a temporary highlight effect
      listingElement.classList.add('highlight-listing');
      setTimeout(() => {
        listingElement.classList.remove('highlight-listing');
      }, 2000);
    }
  }

  private performSearch(searchText: string) {
    this.exitRestoreMode();
    this.filter.search = searchText;
    this.filter.enableZoomFallBack = true;
    this.filterChanges.emit(this.filter);
    this.showSearchChanges.emit([]);
    this.persistListingState();
  }

  onSearch(event: any) {
    this.exitRestoreMode();
    const incomingText = (event ?? '').toString();
    const hadSearchText = this.previousText.trim().length > 0;
    const hasSearchText = incomingText.trim().length > 0;
    if (!hadSearchText && hasSearchText) {
      if (this.map) {
        this.preSearchZoom = this.map.getZoom() ?? null;
        const center = this.map.getCenter()?.toJSON();
        this.preSearchCenter = center ? { ...center } : null;
      } else {
        this.preSearchZoom = null;
        this.preSearchCenter = null;
      }
    }
    this.previousText = incomingText;
    this.persistListingState();
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      const coordinates = Array.isArray(this._resturantCoordinates) ? this._resturantCoordinates : [];
      const searchedRestoList = event != '' ? coordinates.filter(x => x.name?.toLowerCase().includes(event.trim().toLowerCase())) : [];
      if (searchedRestoList.length > 0 && this.areAllPointsInViewport(searchedRestoList)) {
        const searchedData = this.checkPointsInViewport(searchedRestoList);
        if (searchedData.length > 0) {
          const updatedList = searchedData.map((item, i) => ({
            ...item,
            index: i + 1,
            listingIndex: i + 1,
            absoluteIndex: i + 1
          }));
          const ids = updatedList.map(s => s.id);
          // The filtered list re-enters through the coordinates input and the
          // restaurantListUpdated$ subscription; keep the map still on all of them.
          this.searchMapMoveSuppressedUntil = Date.now() + 1500;
          this.showSearchChanges.emit(ids);
          this.updateMapMarkers(updatedList, true);
        }
      } else {
        if (event) {
          this.clearLocation = false;
          this.markers.forEach(m => m.setMap(null));
          if (this.markerClusterer) {
            this.markerClusterer.setMap(null);
            this.markerClusterer = null;
          }
          this.searchChanged.next(event);
        } else {
          this.clearSearchBar();
        }
      }
    }, 1200);
  }

  areAllPointsInViewport(coordinates: any[]): boolean {
    if (!this.map) return false;

    const bounds = this.map.getBounds();
    if (!bounds) return false;

    return coordinates.every(point => {
      const latLng = new google.maps.LatLng(point.lat, point.lng);
      return bounds.contains(latLng);
    })
  }

  checkPointsInViewport(coordinates: any[]): any[] {
    if (!this.map) return [];

    const bounds = this.map.getBounds();
    if (!bounds) return [];

    const visiblePoints = coordinates.filter(point => {
      const latLng = new google.maps.LatLng(point.lat, point.lng);
      return bounds.contains(latLng);
    })

    return visiblePoints;
  }

  private applyFilter(filter: BusinessFilter, isClear: boolean = false) {
    this.exitRestoreMode();
    this.filter = Object.assign({}, filter);
    this.filter.enableZoomFallBack = true;
    this.filterChanges.emit(this.filter);
    this.persistListingState();
    if (isClear) {
      this.showSearchChanges.emit([]);
    }
  }

  onfilter(event: any) {
    this.exitRestoreMode();
    // Update filter values
    let tempSelectedPrice = '';
    let tempSelectedTypeOfMeals = '';
    let tempSelectedCategories = '';

    this.selectedPrices.forEach((x, i) => {
      if (x) {
        tempSelectedPrice = tempSelectedPrice.concat(
          this.priceRanges[i].id.toString() + ', '
        );
      }
    });

    this.selectedTypeOfMeals.forEach((x, i) => {
      if (x) {
        tempSelectedTypeOfMeals = tempSelectedTypeOfMeals.concat(
          this.typeOfMeals[i].id.toString() + ', '
        );
      }
    });

    this.selectedCategories.forEach((x, i) => {
      if (x) {
        tempSelectedCategories = tempSelectedCategories.concat(
          this.categories[i].id.toString() + ', '
        );
      }
    });

    // Update the filter object
    this.filter.FilterByPriceRange = tempSelectedPrice;
    this.filter.FilterByCategories = tempSelectedCategories;
    this.filter.FilterByMealType = tempSelectedTypeOfMeals;

    // Emit the updated filter
    this.filterChanged.next(this.filter);
    this.showSearchChanges.emit([]);
    this.resetToUserLocationIfNoFilters({ emitFilterChange: false });
  }

  QRScanClick() {
    localStorage.setItem("isQRScanClick", "true");
    setTimeout(() => {
      this.isQRScanBtnClick = false;
    }, 300);
  }

  get isclearButtonShow() {
    return (
      !this.searchText ||
      (window.innerWidth < 767 && !this.isSearchBarActive)
    );
  }

  get shouldShowQRButton() {
    return hasNativeScanBridge(window as any);
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: any) {
    let searchBtn = document.querySelector(".btn-search");
    let filterBtn = document.querySelector(".btn-filter");
    let scanBtn = document.querySelector(".btn-scan");
    let searchbar = document.querySelector(".search-wrap");
    if (!searchBtn.contains(event.target) && !searchbar.contains(event.target) && !this.searchText) {
      this.isSearchBarActive = false;
      this.isSearchBtnClick = false;
    }
    const desktopLocation = document.querySelector('.desktop-location-chip');
    if (
      this.isDesktopLocationSearchOpen &&
      desktopLocation &&
      !desktopLocation.contains(event.target)
    ) {
      this.collapseDesktopLocationSearch();
    }
    if (this.isMobileLocationSearchOpen) {
      const mobileLocationEditor = document.querySelector('.mobile-location-dock');
      if (
        !mobileLocationEditor ||
        !mobileLocationEditor.contains(event.target)
      ) {
        this.isMobileLocationSearchOpen = false;
        this.myDrop?.close();
        this.cdr.markForCheck();
      }
    }
    if (!filterBtn.contains(event.target)) {
      this.isFilterBtnClick = false;
    }
    if (scanBtn && !scanBtn.contains(event.target)) {
      this.isQRScanBtnClick = false;
    }
  }

  addToChip(event: any, chip: any, isArticle: boolean, type: ArticleFilterTabType) {
    if (!isArticle) {
      if (event) {
        this.displayFilterChips.push(
          {
            id: this.displayFilterChips?.length,
            name: chip.title,
            isArticle: isArticle,
            type: type
          }
        );
      } else {
        this.displayFilterChips = this.displayFilterChips.filter(x => x.name != chip.title);
      }
    }
  }

  removeChips(removeChip: chips) {
    this.displayFilterChips = this.displayFilterChips.filter(x => x.id !== removeChip.id);
    if (!removeChip.isArticle && removeChip.type === ArticleFilterTabType.CategoryTab) {
      let removeCategoryIndex = this.categories.findIndex(x => x.title == removeChip.name);
      this.selectedCategories[removeCategoryIndex] = false;
    } else if (!removeChip.isArticle && removeChip.type === ArticleFilterTabType.TypeOfMealTab) {
      let removeTypeOfMealIndex = this.typeOfMeals.findIndex(x => x.title == removeChip.name);
      this.selectedTypeOfMeals[removeTypeOfMealIndex] = false;
    } else if (!removeChip.isArticle && removeChip.type === ArticleFilterTabType.PriceRangeTab) {
      let removePriceRangeIndex = this.priceRanges.findIndex(x => x.title == removeChip.name);
      this.selectedPrices[removePriceRangeIndex] = false;
    }
  }

  // The x clears the query and its results. It deliberately leaves the search bar open: the
  // user is still searching and expects to type again, not to be dropped out of search.
  clearSearchBar() {
    this.exitRestoreMode();
    this.collapseDesktopLocationSearch();
    // Drop the in-flight search for the text being cleared. Without this the 1200ms handler
    // and the 300ms searchChanged debounce land *after* the clear and put the old term back.
    clearTimeout(this.searchTimeout);
    this.searchChanged.next('');
    this.searchText = '';
    this.initialAutoZoom = false;
    this.clearLocation = false;
    this.previousText = '';
    this.filter.search = null;
    if (this.map) {
      const currentCenter = this.map.getCenter()?.toJSON();
      const currentZoom = this.map.getZoom();
      const bounds = this.map.getBounds();

      if (currentCenter) {
        this.filter.origin_Lat = currentCenter.lat.toString();
        this.filter.origin_long = currentCenter.lng.toString();
      }

      if (typeof currentZoom === 'number') {
        this.filter.zoomLevel = currentZoom;
      }

      if (bounds) {
        const insetBounds = this.getInsetBounds(bounds, 0.1);
        this.filter.north = insetBounds.north.toString();
        this.filter.south = insetBounds.south.toString();
        this.filter.east = insetBounds.east.toString();
        this.filter.west = insetBounds.west.toString();
      }
    }
    this.filter.enableZoomFallBack = false;
    this.markers.forEach(m => m.setMap(null));
    if (this.markerClusterer) {
      this.markerClusterer.setMap(null);
      this.markerClusterer = null;
    }
    this.preSearchZoom = null;
    this.preSearchCenter = null;
    const updatedFilter = { ...this.filter, search: '' };
    this.showSearchChanges.emit([]);
    this.applyFilter(updatedFilter, true);
    // Load-bearing: clicking the x blurs the input, and onBlur() closes the bar a tick later
    // unless focus is back inside it. This also keeps the keyboard up so typing can continue.
    this.restaurantSearchBarElement?.nativeElement?.focus();
  }

  toggleMobileLocationSearch() {
    this.exitRestoreMode();
    this.isMobileLocationSearchOpen = !this.isMobileLocationSearchOpen;
    if (this.isMobileLocationSearchOpen) {
      this.focusMobileLocationSearch();
    }
    this.cdr.markForCheck();
  }

  openMobileLocationSearch(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    // Measure the pill before it is hidden, so the field can expand out of its footprint.
    const trigger = event?.currentTarget as HTMLElement | null;
    const triggerRect = trigger?.getBoundingClientRect?.();
    this.mobileLocationOriginRect = triggerRect?.width
      ? { left: triggerRect.left, width: triggerRect.width }
      : null;
    if (!this.isMobileLocationSearchOpen) {
      this.exitRestoreMode();
      this.isMobileLocationSearchOpen = true;
      this.focusMobileLocationSearch();
      return;
    }
    this.focusMobileLocationSearch();
  }

  private focusMobileLocationSearch() {
    this.cdr.detectChanges();
    this.mobileLocationDock?.focusInput(true);
    requestAnimationFrame(() => this.mobileLocationDock?.focusInput(true));
    setTimeout(() => this.mobileLocationDock?.focusInput(true), 80);
    setTimeout(() => this.mobileLocationDock?.focusInput(true), 250);
  }

  // From the floating location field: go back to the filter modal.
  closeMobileLocationSearch() {
    this.isMobileLocationSearchOpen = false;
    this.cdr.markForCheck();
  }

  // From the floating location field: bail out into the text search bar mid-type.
  switchListingToSearch() {
    this.isMobileLocationSearchOpen = false;
    this.myDrop?.close();
    this.isSearchBarActive = true;
    this.cdr.detectChanges();
    setTimeout(() => this.restaurantSearchBarElement?.nativeElement?.focus(), 0);
  }

  openDesktopLocationSearch(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (window.innerWidth < 767 || this.isFromMobileApp) {
      return;
    }
    if (!this.isDesktopLocationSearchOpen) {
      this.setDesktopLocationMotion('opening');
    }
    this.isDesktopLocationSearchOpen = true;
    this.cdr.detectChanges();
    this.desktopLocationSearch?.focusInput(true);
    setTimeout(() => this.desktopLocationSearch?.focusInput(true), 0);
    setTimeout(() => this.desktopLocationSearch?.focusInput(true), 150);
  }

  collapseDesktopLocationSearch() {
    if (this.isDesktopLocationSearchOpen) {
      this.setDesktopLocationMotion('closing');
    }
    this.isDesktopLocationSearchOpen = false;
    this.cdr.markForCheck();
  }

  private setDesktopLocationMotion(state: 'opening' | 'closing' | null) {
    if (this.desktopLocationMotionTimeout) {
      clearTimeout(this.desktopLocationMotionTimeout);
      this.desktopLocationMotionTimeout = null;
    }

    const shouldAnimate = window.innerWidth >= 767 && !this.isFromMobileApp;
    this.isDesktopLocationOpening = shouldAnimate && state === 'opening';
    this.isDesktopLocationClosing = shouldAnimate && state === 'closing';

    if (state && shouldAnimate) {
      const duration = state === 'opening' ? 260 : 560;
      this.desktopLocationMotionTimeout = setTimeout(() => {
        this.isDesktopLocationOpening = false;
        this.isDesktopLocationClosing = false;
        this.desktopLocationMotionTimeout = null;
        this.cdr.markForCheck();
      }, duration);
    }
  }

  clearMobileLocation(event?: Event) {
    if (event?.type === 'touchstart') {
      this.lastMobileLocationTouchAt = Date.now();
    } else if (event?.type === 'click' && Date.now() - this.lastMobileLocationTouchAt < 600) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    event?.preventDefault();
    event?.stopPropagation();
    this.isMobileLocationSearchOpen = false;
    this.onLocationSelected(null);
  }

  locationClicked(value: boolean) {
    this.isLocationClicked = value;
    if (!this.isLocationClicked && this.searchText == undefined) {
      this.cdr.detectChanges();
      this.city = '';
      this.selectedLocation = null;
      this.cityEmitted.emit({ city: '', lat: this.defaultCenter.lat, lng: this.defaultCenter.lng, enableZoomFallBack: true });

      // Reset map to default center when location is cleared
      if (this.map) {
        this.map.setCenter(this.defaultCenter);
        this.map.setZoom(this.defaultMaxZoom);
      }
    }
    this.cdr.detectChanges();
  }

  locationHoveredChanged(value: boolean) {
    this.isLocationClicked = value;
  }

  ngOnDestroy() {
    this.persistListingState();
    if (this.desktopLocationMotionTimeout) {
      clearTimeout(this.desktopLocationMotionTimeout);
    }
    this.clearAutoZoomPendingTimeout();
    this.mapInteractionUnsubscribers.forEach(unsub => unsub());
    this.mapInteractionUnsubscribers = [];
    // Cleanup
    this.markers.forEach(marker => marker.map = null);
    this.destroy$.next();
    this.destroy$.complete();
  }

  private restoreListingState() {
    const storedState = this.businessService.hydrateListingState();
    const storedFilterData = storedState?.filterDataObject;
    const storedSearchIds = Array.isArray(storedState?.searchIds) ? storedState.searchIds : [];
    const hasStoredSearchIds = storedSearchIds.length > 0;
    const storedList = storedState?.restaurantDetailsList;
    const storedMeta = storedState?.listMeta;
    const hasStoredList = Array.isArray(storedList) && (storedList.length > 0 || (storedList.length === 0 && typeof storedMeta?.totalRecords === 'number' && storedMeta.totalRecords === 0));
    const shouldRestoreStoredState = this.businessService.shouldRestoreListingState(storedState);
    if (shouldRestoreStoredState && storedFilterData && !this.businessService.filterDataObject) {
      if (storedFilterData.filter) {
        this.filter = Object.assign({}, storedFilterData.filter);
      }
      this.selectedPrices = Array.isArray(storedFilterData.selectedPrices) ? [...storedFilterData.selectedPrices] : [];
      this.selectedTypeOfMeals = Array.isArray(storedFilterData.selectedTypeOfMeals) ? [...storedFilterData.selectedTypeOfMeals] : [];
      this.selectedCategories = Array.isArray(storedFilterData.selectedCategories) ? [...storedFilterData.selectedCategories] : [];
      this.displayFilterChips = Array.isArray(storedFilterData.displayFilterChips) ? [...storedFilterData.displayFilterChips] : [];
      if (this.filter?.search) {
        this.searchText = this.filter.search;
        this.pendingSearchRestore = !hasStoredSearchIds && !hasStoredList && !!this.searchText && this.searchText.trim().length > 0;
      }
      if (storedFilterData.city) {
        this.city = storedFilterData.city;
      }
      if (storedFilterData.selectedLocation) {
        this.selectedLocation = storedFilterData.selectedLocation;
      }
      if (typeof storedFilterData.showOpen === 'boolean' || typeof storedFilterData.showClose === 'boolean') {
        this.showOpen = !!storedFilterData.showOpen;
        this.showClose = !!storedFilterData.showClose;
        this.businessService.setCloseOpenValue({ showOpen: this.showOpen, showClose: this.showClose });
      }
    }

    const hasFiltersInState = shouldRestoreStoredState;
    this.restoredFromSession = !!hasFiltersInState;
    if (hasFiltersInState) {
      const centerFromState = storedState?.currentCenter;
      if (centerFromState?.lat != null && centerFromState?.lng != null) {
        this.restoredMapCenter = {
          lat: Number(centerFromState.lat),
          lng: Number(centerFromState.lng)
        };
        if (centerFromState.zoom != null) {
          this.restoredMapZoom = Number(centerFromState.zoom);
        }
      }

      const storedFilter = storedFilterData?.filter;
      if (!this.restoredMapCenter && storedFilter?.origin_Lat != null && storedFilter?.origin_long != null) {
        this.restoredMapCenter = {
          lat: Number(storedFilter.origin_Lat),
          lng: Number(storedFilter.origin_long)
        };
      }
      if (this.restoredMapZoom == null && storedFilter?.zoomLevel != null) {
        this.restoredMapZoom = Number(storedFilter.zoomLevel);
      }
    }
  }

  private hasActiveFilters(): boolean {
    const hasSearch = !!(this.searchText && this.searchText.trim());
    const hasLocation = !!this.selectedLocation || !!(this.city && this.city.toString().trim());
    const hasPrice = Array.isArray(this.selectedPrices) && this.selectedPrices.some(Boolean);
    const hasType = Array.isArray(this.selectedTypeOfMeals) && this.selectedTypeOfMeals.some(Boolean);
    const hasCategory = Array.isArray(this.selectedCategories) && this.selectedCategories.some(Boolean);
    const hasOpenClose = !!this.showOpen || !!this.showClose;
    return hasSearch || hasLocation || hasPrice || hasType || hasCategory || hasOpenClose;
  }

  private resetToUserLocationIfNoFilters(options?: { emitFilterChange?: boolean }) {
    if (this.hasActiveFilters()) {
      return;
    }
    this.resetToUserLocation(options?.emitFilterChange !== false);
  }

  /**
   * Clearing the location drops the *filter*, not the user's place on the map. Keep the current
   * centre and zoom exactly as they are and simply reload whatever falls inside that viewport —
   * as opposed to resetToUserLocation(), which recentres on the device and re-runs auto-zoom.
   */
  private reloadForCurrentViewport(emitFilterChange = true) {
    this.city = '';
    this.selectedLocation = null;
    this.initialAutoZoom = false;
    this.filter.enableZoomFallBack = false;
    this.preSearchZoom = null;
    this.preSearchCenter = null;

    const center = this.map?.getCenter()?.toJSON();
    if (this.map && center) {
      const zoom = this.map.getZoom();
      const bounds = this.map.getBounds();

      this.defaultCenter = { ...center };
      this.filter.origin_Lat = center.lat.toString();
      this.filter.origin_long = center.lng.toString();
      if (typeof zoom === 'number') {
        this.filter.zoomLevel = zoom;
        this.previousZoom = zoom;
      }
      if (bounds) {
        const insetBounds = this.getInsetBounds(bounds, 0.1);
        this.filter.north = insetBounds.north.toString();
        this.filter.south = insetBounds.south.toString();
        this.filter.east = insetBounds.east.toString();
        this.filter.west = insetBounds.west.toString();
      }
      // The list follows the epicentre; keep it on this viewport so it does not chase the
      // previous location's centre.
      this.lastEpicenter = center;
      this.cityEmitted.emit({ city: '', lat: center.lat, lng: center.lng, enableZoomFallBack: false });
    }

    if (emitFilterChange) {
      this.filterChanges.emit(this.filter);
    }
    this.persistListingState();
    this.cdr.markForCheck();
  }

  private resetToUserLocation(emitFilterChange: boolean) {
    if (this.isResettingToUserLocation) {
      return;
    }
    this.isResettingToUserLocation = true;

    const applyCenter = (center: google.maps.LatLngLiteral) => {
      this.defaultCenter = { ...center };
      this.filter.origin_Lat = center.lat.toString();
      this.filter.origin_long = center.lng.toString();
      this.filter.zoomLevel = this.defaultMaxZoom;
      this.filter.enableZoomFallBack = true;

      if (this.map) {
        this.map.setCenter(center);
        this.map.setZoom(this.defaultMaxZoom);
        const bounds = this.map.getBounds();
        if (bounds) {
          const insetBounds = this.getInsetBounds(bounds, 0.1);
          this.filter.north = insetBounds.north.toString();
          this.filter.south = insetBounds.south.toString();
          this.filter.east = insetBounds.east.toString();
          this.filter.west = insetBounds.west.toString();
        }
      }

      this.city = '';
      this.selectedLocation = null;
      this.cityEmitted.emit({ city: '', lat: center.lat, lng: center.lng, enableZoomFallBack: true });
      if (emitFilterChange) {
        this.filterChanges.emit(this.filter);
      }
      this.persistListingState();
      this.isResettingToUserLocation = false;
      this.cdr.markForCheck();
    };

    if (this.userCenter) {
      applyCenter(this.userCenter);
      return;
    }

    this.userService.getCurrentLatLng().then((position) => {
      this.userCenter = { lat: Number(position.lat), lng: Number(position.lng) };
      applyCenter(this.userCenter);
    }, () => {
      this.isResettingToUserLocation = false;
    });
  }

  private tryApplyRestoredSearch() {
    if (!this.pendingSearchRestore) {
      return;
    }
    if (!this.searchText || !this.searchText.trim()) {
      this.pendingSearchRestore = false;
      return;
    }
    if (!Array.isArray(this._resturantCoordinates) || this._resturantCoordinates.length === 0) {
      return;
    }
    if (!this.map) {
      return;
    }
    const text = this.searchText;
    this.pendingSearchRestore = false;
    this.onSearch(text);
  }

  private exitRestoreMode() {
    if (this.restoredFromSession) {
      this.restoredFromSession = false;
    }
    if (this.pendingSearchRestore) {
      this.pendingSearchRestore = false;
    }
  }

  private registerMapInteractionListeners() {
    if (!this.mapElement?.nativeElement) {
      return;
    }
    if (this.mapInteractionUnsubscribers.length > 0) {
      return;
    }
    const element = this.mapElement.nativeElement;
    this.mapInteractionUnsubscribers.push(this.renderer.listen(element, 'wheel', () => this.exitRestoreMode()));
    this.mapInteractionUnsubscribers.push(this.renderer.listen(element, 'mousedown', () => this.exitRestoreMode()));
    this.mapInteractionUnsubscribers.push(this.renderer.listen(element, 'touchstart', () => this.exitRestoreMode()));
  }

  private persistListingState() {
    // BusinessFilter is flat scalars; a spread snapshots it without serialising.
    const filterSnapshot = this.filter ? { ...this.filter } : null;
    if (filterSnapshot && this.searchText !== undefined) {
      filterSnapshot.search = this.searchText;
    }
    const filterDataObject = {
      filter: filterSnapshot,
      selectedPrices: Array.isArray(this.selectedPrices) ? [...this.selectedPrices] : [],
      selectedTypeOfMeals: Array.isArray(this.selectedTypeOfMeals) ? [...this.selectedTypeOfMeals] : [],
      selectedCategories: Array.isArray(this.selectedCategories) ? [...this.selectedCategories] : [],
      displayFilterChips: Array.isArray(this.displayFilterChips) ? [...this.displayFilterChips] : [],
      city: this.isDashboardLocationIntent ? '' : this.city,
      selectedLocation: this.isDashboardLocationIntent ? null : this.selectedLocation,
      showOpen: this.showOpen,
      showClose: this.showClose
    };
    const mapCenter = this.map?.getCenter()?.toJSON();
    const mapZoom = this.map?.getZoom();
    let currentCenter = null;
    if (mapCenter) {
      const bounds = this.map?.getBounds();
      const inset = bounds ? this.getInsetBounds(bounds, 0.1) : null;
      currentCenter = {
        lat: mapCenter.lat,
        lng: mapCenter.lng,
        zoom: mapZoom ?? this.filter?.zoomLevel,
        north: inset?.north,
        south: inset?.south,
        east: inset?.east,
        west: inset?.west,
        enableZoomFallBack: this.filter?.enableZoomFallBack
      };
    }
    const nextState: any = { filterDataObject };
    if (currentCenter) {
      nextState.currentCenter = currentCenter;
    }
    this.businessService.saveListingState(nextState);
  }

  // Update the onScrollDown method to track pagination
  onScrollDown() {
    if (this.totalPage && this.currentPage < this.totalPage) {
      this.currentPage += 1;
      // Update baseIndex for marker numbering
      this.baseIndex = this.currentPage * this.limit;
      this.loadDataSubject.next();
    }
  }

  onBlur() {
    setTimeout(() => {
      const activeElement = document.activeElement;
      const isInsideContainer = this.restaurantSearchBarElement?.nativeElement.contains(activeElement);
      if (!isInsideContainer) {
        this.isSearchBarActive = false;
        this.cdr.detectChanges();
      }
    }, 0);
  }

  preventScrollClose(event: Event) {
    event.stopPropagation();
  }

  onDropdownShown() {
    this.setDropdownHeight();
  }

  setDropdownHeight(retries = 10) {
    const dropdown1 = this.filterDropdownMenu?.nativeElement;
    const scrollContainer = this.scrollBarContainerRef?.nativeElement;
    if (!dropdown1 || !scrollContainer || retries === 0) return;
    const element = document.getElementById('dropdown-filter');
    element.removeAttribute('ngbdropdowntoggle');
    const spaceFromTop = dropdown1.getBoundingClientRect();
    if (spaceFromTop.top > 0) {
      scrollContainer.addEventListener('scroll', () => this.onScroll(scrollContainer), { passive: true });
    }
    else {
      setTimeout(() => this.setDropdownHeight(retries - 1), 50);
    }
  }

  onScroll(el: HTMLElement) {
    this.renderer.addClass(el, 'scrolling');
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
      this.renderer.removeClass(el, 'scrolling');
    }, 1000);
  }

  getInsetBounds(bounds: google.maps.LatLngBounds, insetFactor = 0.1) {
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();

    const centerLat = (ne.lat() + sw.lat()) / 2;
    const centerLng = (ne.lng() + sw.lng()) / 2;

    const halfLatSpan = (ne.lat() - sw.lat()) / 2;
    const halfLngSpan = (ne.lng() - sw.lng()) / 2;

    const newHalfLatSpan = halfLatSpan * (1 - insetFactor);
    const newHalfLngSpan = halfLngSpan * (1 - insetFactor);

    return {
      north: centerLat + newHalfLatSpan,
      south: centerLat - newHalfLatSpan,
      east: centerLng + newHalfLngSpan,
      west: centerLng - newHalfLngSpan
    }
  }
}
